import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import AppProviders from './AppProviders';
import { RefreshProvider } from './contexts/RefreshContext';
import { MessageProvider } from './contexts/MessageContext'; // Import the MessageProvider
import config from '../src/config.json'; 
import { MQProvider } from './contexts/MQContext';
import { NotificationsProvider } from './contexts/NotificationsContext';

class Root extends Component {


  componentDidMount() {
    // Set the primary color from config
    if (config.color) {
      document.documentElement.style.setProperty("--primary-color", config.color);
    }
  }


  render() {

    return (
      <RefreshProvider>
        <MessageProvider>
          <MQProvider>
            <NotificationsProvider>
              <AppProviders>
                <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                  <App />
                </Router>
              </AppProviders>
            </NotificationsProvider>
          </MQProvider>
        </MessageProvider>
      </RefreshProvider>
    );
  }
}

export default Root;